import { styled } from '../../styled-components';
import { Button } from '../Button/Button';

export const ButtonStyled = styled(Button)`
  position: relative;
`;
